'use client';

import { MarketType } from '@drift-labs/sdk';
import useMarketMaxLeverage from 'src/hooks/useMarketMaxLeverages';
import useHighLeverageSpotsOpen from 'src/hooks/useHighLeverageSpotsOpen';
import VariantTag from 'src/components/Tags/VariantTag';

const MarketLeverageTag = ({
	marketType,
	marketIndex,
}: {
	marketType: MarketType;
	marketIndex: number;
}) => {
	const { highLeverageSpotsOpen } = useHighLeverageSpotsOpen();

	const { maxLeverage, highLeverageMaxLeverage, hasHighLeverage } =
		useMarketMaxLeverage(marketType, marketIndex);

	if (!maxLeverage) {
		return null;
	}

	const canUseHighLeverage = hasHighLeverage && highLeverageSpotsOpen > 0;

	return (
		<div className="flex flex-row items-center gap-x-xs">
			{!canUseHighLeverage && (
				<VariantTag variant="leverage">{maxLeverage}x</VariantTag>
			)}

			{canUseHighLeverage && !!highLeverageMaxLeverage && (
				<VariantTag variant="leverage">{highLeverageMaxLeverage}x</VariantTag>
			)}
		</div>
	);
};

export default MarketLeverageTag;
